<template>
  <div id="app" class="app">
    <nav-bar />
    <div class="main-div">
      <router-view />
    </div>
    <footer-bar />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import menu from "@/menu.js";
import NavBar from "@/components/NavBar.vue";
// import AsideMenu from '@/components/AsideMenu.vue'
import FooterBar from "@/components/FooterBar.vue";
import { getLoginNotify } from "@/api/user";

export default defineComponent({
  name: "AppComponent",
  components: {
    FooterBar,
    NavBar,
  },
  data() {
    return {
      menu,
      loginNotifyTimer: null,
      loginNotifyChecking: false,
    };
  },
  computed: {
    userToken() {
      return this.$store.getters.getUserToken;
    },
  },
  watch: {
    userToken: {
      immediate: true,
      handler(token) {
        if (token) {
          this.startLoginNotifyCheck();
        } else {
          this.stopLoginNotifyCheck();
        }
      },
    },
  },
  created() {
    console.log(this.$store.state);
  },
  beforeDestroy() {
    this.stopLoginNotifyCheck();
  },
  methods: {
    startLoginNotifyCheck() {
      if (this.loginNotifyTimer) {
        return;
      }
      this.loginNotifyTimer = setInterval(() => {
        this.checkLoginNotify();
      }, 10000);
      this.checkLoginNotify();
    },
    stopLoginNotifyCheck() {
      if (this.loginNotifyTimer) {
        clearInterval(this.loginNotifyTimer);
        this.loginNotifyTimer = null;
      }
    },
    checkLoginNotify() {
      if (this.loginNotifyChecking || !this.userToken) {
        return;
      }
      this.loginNotifyChecking = true;
      getLoginNotify()
        .then((res) => {
          if (res && res.data && res.data.type === "login_notify") {
            this.showLoginNotifyDialog(res.data);
          }
        })
        .catch((err) => {
          console.error("检查登录通知失败", err);
        })
        .finally(() => {
          this.loginNotifyChecking = false;
        });
    },
    showLoginNotifyDialog(msg) {
      const loginTime = this.formatTimestamp(msg.loginTime);
      const content = `您的账号于 ${loginTime} 在 ${msg.loginLocation || "新设备"} 登录<br>登录IP：${msg.loginIp || "未知"}<br>设备：${msg.deviceName || "未知设备"}<br><br>如非本人操作，请及时修改密码`;
      this.$buefy.dialog.alert({
        title: msg.title || "账号异地登录提醒",
        message: content,
        type: "is-warning",
        confirmText: "知道了",
        hasIcon: true,
        canCancel: ["x", "escape", "outside"],
      });
    },
    formatTimestamp(timestamp) {
      if (!timestamp) {
        return "未知时间";
      }
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      const second = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
  },
});
</script>
<style lang="scss">
.app {
  margin: 0 auto;
  max-width: 1920px;
}

@media (max-width: 1200px) {
  html {
    width: 100%;
    height: 100%;
    overflow-x: auto;
  }
}

.main-div {
  box-sizing: border-box;
}

.modal {
  z-index: 10000 !important;
}

.no-data {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  img {
    width: 300px;
    height: 300px;
  }

  .no-data-text {
    font-size: 16px;
    color: #999;
    text-align: center;
  }
}

//@font-face {
//  font-family: 'SourceHanSansSC';
//  src: url('@/assets/fonts/SourceHanSansSC-Medium.otf') format('opentype');
//  font-weight: normal;
//  font-style: normal;
//}
//
//@font-face {
//  font-family: 'SourceHanSansSCNomal';
//  src: url('@/assets/fonts/SourceHanSansSC-Normal.otf') format('opentype');
//  font-weight: normal;
//  font-style: normal;
//}
</style>
